import { Directive, ElementRef, Input } from "@angular/core";
import { TooltipOptions } from "leaflet";

@Directive({
    selector: "[dtmMapLeafletTooltipContent]",
})
export class LeafletTooltipContentDirective {
    @Input() public tooltipOptions: TooltipOptions = {};

    constructor(public elem: ElementRef) {}
}
